'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { SvgIcon } from '@s7/base';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const StoresHorizontalGoogleEn = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ jsxs(SvgIcon, _extends({
        width: 135,
        height: 40,
        fill: "none",
        viewBox: "0 0 135 40"
    }, props, {
        ref: ref,
        children: [
            /*#__PURE__*/ jsx("path", {
                fill: "url(#GoogleEn_svg__paint0_linear_966_1805)",
                d: "M10.4 7.5c-.3.3-.5.8-.5 1.4V31c0 .6.2 1.1.5 1.4l.1.1 12.4-12.4v-.2z"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "url(#GoogleEn_svg__paint1_linear_966_1805)",
                d: "m27 24.3-4.1-4.1v-.3l4.1-4.1.1.1 4.9 2.8c1.4.8 1.4 2.1 0 2.9z"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "url(#GoogleEn_svg__paint2_linear_966_1805)",
                d: "M27.1 24.2 22.9 20 10.4 32.5c.5.5 1.2.5 2.1.1z"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "url(#GoogleEn_svg__paint3_linear_966_1805)",
                d: "M27.1 15.8 12.5 7.5c-.9-.5-1.6-.4-2.1.1L22.9 20z"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "white",
                fillRule: "evenodd",
                d: "M45.773 12.901q.18-.16.282-.292v-2.452h-2.426v.844h1.318v1.252a1.018 1.018 0 0 1-.378.255 2 2 0 0 1-.345.095 3 3 0 0 1-.49.037q-.386 0-.692-.145a1.4 1.4 0 0 1-.518-.422 2 2 0 0 1-.328-.683 3.5 3.5 0 0 1-.114-.934v-.43q0-.52.094-.926.095-.406.286-.685.191-.28.48-.425.286-.145.678-.145.326 0 .56.088.235.089.396.242.16.154.253.365.092.21.131.461h1.09a2.8 2.8 0 0 0-.228-.824 2 2 0 0 0-.47-.648 2.1 2.1 0 0 0-.734-.424 3.1 3.1 0 0 0-1.02-.152q-.62 0-1.107.207a2.2 2.2 0 0 0-.826.602 2.7 2.7 0 0 0-.519.969q-.18.573-.18 1.303v.422q0 .734.2 1.305t.56.962.864.598q.502.207 1.105.207.536 0 .934-.095.398-.094.68-.233.285-.138.464-.299m2.545.45q.422.177.95.177.355 0 .64-.077t.513-.203a1.9 1.9 0 0 0 .679-.617l-.576-.55a1.6 1.6 0 0 1-.508.436 1.4 1.4 0 0 1-.687.158 1.183 1.183 0 0 1-1.145-.765 1.7 1.7 0 0 1-.117-.51h3.107v-.456q0-.514-.123-.945a2.1 2.1 0 0 0-.373-.743 1.7 1.7 0 0 0-.633-.485 2.2 2.2 0 0 0-.901-.174q-.453 0-.846.174-.393.173-.683.492-.29.318-.457.773a3 3 0 0 0-.167 1.018v.175q0 .488.158.91.157.421.453.73.294.307.716.483m.112-3.59a.9.9 0 0 1 .71-.307 1 1 0 0 1 .446.09q.182.09.296.242.115.15.17.347.054.195.068.406v.08h-2.035q.075-.55.345-.858m4.91-1.076V7.529h-1.067v1.156h-.782v.79h.782v2.717q0 .369.092.624.093.255.257.413.165.158.391.228.227.07.49.07.238 0 .407-.032a4 4 0 0 0 .297-.068V12.6a2 2 0 0 1-.16.029q-.104.015-.214.015a1 1 0 0 1-.2-.02.36.36 0 0 1-.156-.074.34.34 0 0 1-.101-.156.8.8 0 0 1-.035-.264V9.476h.84v-.791zm3.965 4.755h1.068V8.685h-1.068zm.09-6.399a.57.57 0 0 0-.156.409q0 .241.156.402.156.16.446.16t.448-.16a.55.55 0 0 0 .158-.402q0-.246-.158-.409t-.448-.162-.446.162m3.478 1.644V7.529h-1.068v1.156h-.782v.79h.782v2.717q0 .369.093.624.092.255.256.413.165.158.392.228.225.07.49.07.237 0 .406-.032.17-.033.297-.068V12.6a2 2 0 0 1-.16.029 1.4 1.4 0 0 1-.214.015 1 1 0 0 1-.2-.02.36.36 0 0 1-.156-.074.34.34 0 0 1-.1-.156.8.8 0 0 1-.036-.264V9.476h.84v-.791zm3.848 1.373a3 3 0 0 0-.152.96v.093q0 .518.151.962.153.444.436.767.282.323.694.505.41.183.934.183.517 0 .93-.183.41-.182.694-.505.283-.323.432-.767t.15-.962v-.093q0-.518-.15-.96a2.3 2.3 0 0 0-.433-.767 2 2 0 0 0-.696-.51 2.3 2.3 0 0 0-.936-.184 2.2 2.2 0 0 0-.927.184 2 2 0 0 0-.692.51 2.3 2.3 0 0 0-.436.767m.982 1.659a2.7 2.7 0 0 1-.066-.606v-.093q0-.315.066-.6.066-.283.206-.496a.98.98 0 0 1 .866-.468 1 1 0 0 1 .874.468q.141.213.21.496.067.285.067.6v.093q0 .32-.068.606t-.206.499-.356.336a1 1 0 0 1-.512.123q-.3 0-.517-.123a1.03 1.03 0 0 1-.358-.336 1.5 1.5 0 0 1-.206-.499m5.212-2.483-.031-.55h-1.007v4.756h1.068v-3.384a1.15 1.15 0 0 1 .39-.426 1.03 1.03 0 0 1 .573-.159q.202 0 .358.047a.6.6 0 0 1 .422.426q.055.17.055.415v3.08h1.068v-3.071q0-.483-.108-.822a1.4 1.4 0 0 0-.306-.55 1.15 1.15 0 0 0-.476-.305 2 2 0 0 0-.622-.094 1.74 1.74 0 0 0-1.384.637M47.69 24.674V22.85h6.285c.102.304.102.71.102 1.115 0 1.318-.406 3.041-1.622 4.258-1.217 1.318-2.636 1.926-4.664 1.926-3.65 0-6.792-3.041-6.792-6.691s3.143-6.69 6.792-6.69c2.028 0 3.447.81 4.562 1.824l-1.318 1.318c-.81-.71-1.926-1.318-3.345-1.318-2.636 0-4.765 2.129-4.765 4.866s2.028 4.866 4.765 4.866c1.723 0 2.737-.71 3.345-1.318.507-.507.913-1.318 1.014-2.331zm6.894 1.217c0-2.534 1.926-4.36 4.359-4.36s4.36 1.724 4.36 4.36c0 2.535-1.927 4.36-4.36 4.36a4.327 4.327 0 0 1-4.36-4.36m13.787-4.36c-2.433 0-4.36 1.826-4.36 4.36a4.327 4.327 0 0 0 4.36 4.36c2.433 0 4.36-1.826 4.36-4.36 0-2.636-1.927-4.36-4.36-4.36m0 6.895c-1.318 0-2.433-1.115-2.433-2.636 0-1.52 1.115-2.636 2.433-2.636s2.433 1.014 2.433 2.636c0 1.52-1.115 2.636-2.433 2.636m-9.428 0c-1.318 0-2.433-1.115-2.433-2.636 0-1.52 1.115-2.636 2.433-2.636s2.433 1.014 2.433 2.636c0 1.52-1.115 2.636-2.433 2.636m34.773-4.157c-.406-1.014-1.42-2.737-3.65-2.737s-4.055 1.723-4.055 4.36c0 2.432 1.825 4.358 4.258 4.358 1.926 0 3.142-1.216 3.548-1.926l-1.42-1.014c-.506.71-1.114 1.217-2.128 1.217s-1.622-.406-2.13-1.318l5.78-2.433zm-3.65-1.115c-.912 0-2.23.912-2.23 2.534l3.852-1.622c-.203-.506-.912-.912-1.622-.912m-6.995 6.69h1.926V17.173h-1.926zm-5.373-8.413c1.014 0 1.825.506 2.332 1.013v-.71h1.824v7.705c0 3.143-1.824 4.461-4.055 4.461-2.129 0-3.345-1.42-3.852-2.534l1.622-.71c.203.71 1.014 1.52 2.129 1.52 1.42 0 2.332-.912 2.332-2.534v-.608h-.102c-.405.507-1.216 1.014-2.23 1.014-2.23 0-4.157-1.825-4.157-4.258s2.028-4.36 4.157-4.36m.101 6.995c-1.318 0-2.433-1.115-2.433-2.636 0-1.52 1.115-2.636 2.433-2.636s2.332 1.115 2.332 2.636c0 1.52-1.014 2.636-2.332 2.636m20.175-11.253h4.562c2.129 0 4.156 1.52 4.156 3.953s-2.027 3.954-4.156 3.954h-2.636v4.765h-1.926zm4.663 6.082h-2.737v-4.359h2.737c1.419 0 2.23 1.217 2.23 2.13-.101 1.114-.912 2.23-2.23 2.23m8.313.102c.507-1.318 1.926-1.926 3.345-1.926 2.129 0 3.853 1.317 4.056 3.548v4.866h-1.825v-1.014h-.102c-.507.608-1.115 1.217-2.433 1.217-1.622 0-3.142-1.115-3.142-2.839 0-1.825 1.824-2.838 3.649-2.838.811 0 1.622.304 1.926.506v-.1c-.101-1.015-1.013-1.623-2.027-1.623-.71 0-1.318.203-1.724.912zm3.143 5.069c-.609 0-1.521-.304-1.521-1.115 0-1.014 1.115-1.318 2.028-1.318.729 0 1.13.164 1.572.344l.151.061c-.203 1.217-1.217 2.028-2.23 2.028m8.515-1.217 2.129-5.474h2.028l-5.17 11.962h-1.927l1.927-4.258-3.346-7.704h2.028l2.23 5.474zm-14.902 2.636h1.926V17.173h-1.926z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ jsxs("defs", {
                children: [
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "GoogleEn_svg__paint0_linear_966_1805",
                        x1: 17.436,
                        x2: -2.431,
                        y1: -7.427,
                        y2: -2.055,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#00A0FF"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.007,
                                stopColor: "#00A1FF"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.26,
                                stopColor: "#00BEFF"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.512,
                                stopColor: "#00D2FF"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.76,
                                stopColor: "#00DFFF"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 1,
                                stopColor: "#00E3FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "GoogleEn_svg__paint1_linear_966_1805",
                        x1: 33.834,
                        x2: 9.637,
                        y1: 9.87,
                        y2: 9.87,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#FFE000"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.409,
                                stopColor: "#FFBD00"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.775,
                                stopColor: "#FFA500"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 1,
                                stopColor: "#FF9C00"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "GoogleEn_svg__paint2_linear_966_1805",
                        x1: 10.083,
                        x2: -5.883,
                        y1: 13.514,
                        y2: 40.318,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#FF3A44"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 1,
                                stopColor: "#C31162"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "GoogleEn_svg__paint3_linear_966_1805",
                        x1: 0.683,
                        x2: 7.756,
                        y1: 4.079,
                        y2: 16.065,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#32A071"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.069,
                                stopColor: "#2DA771"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.476,
                                stopColor: "#15CF74"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 0.801,
                                stopColor: "#06E775"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: 1,
                                stopColor: "#00F076"
                            })
                        ]
                    })
                ]
            })
        ]
    })));

export { StoresHorizontalGoogleEn, StoresHorizontalGoogleEn as default };
//# sourceMappingURL=StoresHorizontalGoogleEn.js.map
